import { useIntl } from "react-intl";
import { useToast } from "@packsize/toast";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { reclosePackagingSolution } from "@/api/production-api";

import { CLOSING_HISTORY_QUERY_KEY } from "./use-closing-history";

export const useReclosePackagingSolution = (packagingSolutionId: string) => {
	const intl = useIntl();
	const { toastSuccess, toastError } = useToast();
	const queryClient = useQueryClient();

	const mutation = useMutation({
		mutationFn: () => reclosePackagingSolution(packagingSolutionId),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [CLOSING_HISTORY_QUERY_KEY] });
			toastSuccess({
				message: intl.formatMessage({ id: "Marked as Re-Closed", defaultMessage: "Marked as Re-Closed" }),
			});
		},
		onError: (error: unknown) => {
			console.error("Failed to re-close", error);
			toastError({
				message: intl.formatMessage({ id: "Failed to Re-close", defaultMessage: "Failed to Re-close" }),
			});
		},
	});

	return {
		reclose: () => mutation.mutate(),
		isReclosing: mutation.isPending,
		isSuccess: mutation.isSuccess,
		isError: mutation.isError,
	};
};
